import { Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import type { ServiceConnectionType } from '@/api/model'
import { serviceConnectionTypes } from '../registry'
import { ServiceConnectionTypeIcon } from '../components/ServiceConnectionTypeIcon'

interface Props {
  onSelectType: (type: ServiceConnectionType) => void
}

/** Picking the type here keeps it immutable in the dialog — the backend rejects a change. */
export function CreateServiceConnectionButton({ onSelectType }: Props) {
  const { t } = useTranslation('service-connections')

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="gap-2">
          <Plus className="h-4 w-4" />
          <span className="hidden sm:inline">{t('actions.create')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {serviceConnectionTypes.map((definition) => (
          <DropdownMenuItem key={definition.type} onClick={() => onSelectType(definition.type)}>
            <ServiceConnectionTypeIcon icon={definition.icon} className="mr-2" />
            {t(definition.labelKey)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
